import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import JobList from "./pages/JobList";
import JobDetail from "./pages/JobDetail";
import Applications from "./pages/Applications";
import Documents from "./pages/Documents";
import Messages from "./pages/Messages";
import Settings from "./pages/Settings";

// Employer Pages
import CreateJob from "./pages/employer/CreateJob";
import EmployerJobs from "./pages/employer/EmployerJobs";
import EmployerApplications from "./pages/employer/EmployerApplications";
import EmployerProfile from "./pages/employer/EmployerProfile";
import SkillHeatmap from "./pages/employer/SkillHeatmap";

// New Feature Pages
import AusbildungRescue from "./pages/AusbildungRescue";
import Anerkennung from "./pages/Anerkennung";
import SeniorModels from "./pages/SeniorModels";
import Pricing from "./pages/Pricing";
import Imprint from "./pages/Imprint";
import BlockedJobs from "./pages/BlockedJobs";
import TelekomPilot from "./pages/TelekomPilot";

// Employer Pages
import Redeployment from "./pages/employer/Redeployment";

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/imprint" element={<Imprint />} />
      
      {/* Protected Routes - Applicant */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute>
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/jobs" element={
        <ProtectedRoute>
          <JobList />
        </ProtectedRoute>
      } />
      <Route path="/jobs/:jobId" element={
        <ProtectedRoute>
          <JobDetail />
        </ProtectedRoute>
      } />
      <Route path="/applications" element={
        <ProtectedRoute>
          <Applications />
        </ProtectedRoute>
      } />
      <Route path="/documents" element={
        <ProtectedRoute>
          <Documents />
        </ProtectedRoute>
      } />
      <Route path="/messages" element={
        <ProtectedRoute>
          <Messages />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute>
          <Settings />
        </ProtectedRoute>
      } />
      <Route path="/rescue" element={
        <ProtectedRoute>
          <AusbildungRescue />
        </ProtectedRoute>
      } />
      <Route path="/anerkennung" element={
        <ProtectedRoute>
          <Anerkennung />
        </ProtectedRoute>
      } />
      <Route path="/senior" element={
        <ProtectedRoute>
          <SeniorModels />
        </ProtectedRoute>
      } />
      <Route path="/pricing" element={
        <ProtectedRoute>
          <Pricing />
        </ProtectedRoute>
      } />
      <Route path="/blocked" element={
        <ProtectedRoute>
          <BlockedJobs />
        </ProtectedRoute>
      } />
      <Route path="/telekom-pilot" element={
        <ProtectedRoute>
          <TelekomPilot />
        </ProtectedRoute>
      } />

      {/* Protected Routes - Employer */}
      <Route path="/employer/jobs" element={
        <ProtectedRoute>
          <EmployerJobs />
        </ProtectedRoute>
      } />
      <Route path="/employer/jobs/new" element={
        <ProtectedRoute>
          <CreateJob />
        </ProtectedRoute>
      } />
      <Route path="/employer/applications" element={
        <ProtectedRoute>
          <EmployerApplications />
        </ProtectedRoute>
      } />
      <Route path="/employer/profile" element={
        <ProtectedRoute>
          <EmployerProfile />
        </ProtectedRoute>
      } />
      <Route path="/employer/heatmap" element={
        <ProtectedRoute>
          <SkillHeatmap />
        </ProtectedRoute>
      } />
      <Route path="/employer/redeployment" element={
        <ProtectedRoute>
          <Redeployment />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
